import React, { Component } from "react";
import { Link } from "react-router-dom";
import { LinkButton1 } from "../button/button";
import "./navbar.css";
class Navbar extends Component {
	render() {
		return (
			<div className="navbar-area navbar-two">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<nav className="navbar navbar-expand-lg">
								<Link className="navbar-brand" to="/">
									{/* <img
                    src="https://cdn.discordapp.com/attachments/789379278902525974/789845281033158686/2318014-512.png"
                    alt="Logo"
                    height="80px"
                  /> */}
								</Link>

								<button
									className="navbar-toggler"
									type="button"
									data-toggle="collapse"
									data-target="#navbarTwo"
									aria-controls="navbarTwo"
									aria-expanded="false"
									aria-label="Toggle navigation"
								>
									<span className="toggler-icon"></span>
									<span className="toggler-icon"></span>
									<span className="toggler-icon"></span>
								</button>

								<div
									className="collapse navbar-collapse sub-menu-bar"
									id="navbarTwo"
								>
									<ul className="navbar-nav m-auto">
										<li className="nav-item">
											<Link className="page-scroll" to="/">
												Home
											</Link>
										</li>
										{/* <li className="nav-item">
                      <Link className="page-scroll" to="/about">
                        About
                      </Link>
                    </li> */}
										{/* <li className="nav-item">
											<Link className="page-scroll" to="/announcements">
												Announcements
											</Link>
										</li> */}
										<li className="nav-item">
											<Link className="page-scroll" to="/committee">
												Committee
											</Link>
										</li>

										<li className="nav-item">
											<Link className="page-scroll" to="/keynotes">
												Keynotes
											</Link>
										</li>
										{/* <li className="nav-item">
											<Link className="page-scroll" to="/tracks">
												Tracks
											</Link>
										</li> */}
										<li className="nav-item">
											<Link className="page-scroll" to="/callforpapers">
												Call For Papers
											</Link>
										</li>
										<li className="nav-item">
											<Link className="page-scroll" to="/publications">
												Publications
											</Link>
										</li>

										<li className="nav-item">
											<Link className="page-scroll" to="/dates">
												Dates
											</Link>
										</li>
										<li className="nav-item">
											<Link className="page-scroll" to="/submission">
												Submission
											</Link>
										</li>
										<li className="nav-item">
											<Link className="page-scroll" to="/register">
												Registration
											</Link>
										</li>
										<li className="nav-item">
											<Link className="page-scroll" to="/contact">
												Contact
											</Link>
										</li>
									</ul>
								</div>

								<div className="navbar-btn d-sm-inline-block register-btn"></div>
							</nav>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Navbar;
